import React, {useEffect, useState} from 'react';
import {
    Container,
    FilledInput,
    FormControl, FormControlLabel, FormGroup,
    Grid,
    InputLabel,
    MenuItem,
    Pagination,
    Select, Switch,
    Typography,
    Tabs, Tab, Box
} from "@mui/material";
import TripCard from "../MyBooking/TripCard";
import {isDealerSite, requestApi} from "../../../utils/utils";
import {useAuthUser, useSignOut} from "react-auth-kit";
import PrimaryButton from "../../Common/PrimaryButton";
import {endOfDay, isFuture, isPast, parse} from "date-fns";
import SecondaryButton from "../../Common/SecondaryButton";
import Spinner from "../../../utils/Spinner/Spinner";
import ActivityCard from "../../Booking/DayTripBooking/ActivityCard";
import FareharborBookingCard from "../MyBooking/FareharborBookingCard";
import {makeStyles, withStyles} from "@mui/styles";
import PropTypes from "prop-types";
const NautilusTabs = withStyles((theme) => ({
    root: {
        '& button': {
            textDecoration: 'none',
            backgroundColor: '#f2fbfe !important',
            textTransform: 'initial',
        },
    },
    indicator: {
        backgroundColor: '#1ebce7',
    },
}))(Tabs);
const NautilusTab = withStyles((theme) => ({

    root: {
        padding: 15,
        fontSize: '1.8rem',
        color: '#00b7f0',
        '&:hover': {
            color: '#0087bd',
            opacity: 1,
        },
        '&$selected': {
            color: '#0087bd',
            fontWeight: theme.typography.fontWeightMedium,
        },
        '&:focus': {
            color: '#0087bd',
        },
    }
}))((props) => <Tab disableRipple {...props} />);

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

const BookingList = () => {
    const user = useAuthUser();
    const [upcomingTrips, setUpcomingTrips] = useState([]);
    const [previousTrips, setPreviousTrips] = useState([]);
    const [destinations, setDestinations] = useState([]);
    const [filters, setFilters] = useState({
        confirmation: '',
        destination: '',
        year: '',
        month: '',
    });
    const [bookingUserId,setBookingUserId] = useState(user().id);
    const [relatedAccounts,setRelatedAccounts] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [count, setCount] = useState(1);
    const [loadingBookings, setLoadingBookings] = useState(false);
    const [resultsPerPage, setResultsPerPage] = useState(10);

    const [selectedTab, setSelectedTab] = useState(0); // 0 = Multi-day, 1 = Day-trip

    const handleTabChange = (event, newValue) => {
        setSelectedTab(newValue);
        setCurrentPage(1);
        setLoadingBookings(true);
        setPreviousTrips([]);
        setUpcomingTrips([]);
    };


    const signOut = useSignOut();

    const totalResults = upcomingTrips.length + previousTrips.length;

    useEffect(() => {
        fetchDestinations().catch();
        getUserTrips().catch();
    }, [currentPage, selectedTab]);

    const getUserTrips = async () => {
        try {
            let queryString = `?page=${currentPage}`;
            if (filters.confirmation) queryString += `&confirmation=${filters.confirmation}`;
            if (filters.destination) queryString += `&destination=${filters.destination}`;
            if (filters.year) queryString += `&year=${filters.year}`;
            if (filters.month) queryString += `&month=${filters.month}`;

            setLoadingBookings(true);
            setPreviousTrips([]);
            setUpcomingTrips([]);

            const url = selectedTab === 1
                ? `/activities/getBookings/${bookingUserId}${queryString}`
                : `/bookings/get/${bookingUserId}${queryString}`;

            const { data } = await requestApi(url);
            setLoadingBookings(false);

            if (data.status === 'success') {
                let format = selectedTab === 1 ? 'yyyy-MM-dd HH:mm:ss' : 'yyyy-MM-dd';
                const { previousTrips, upcomingTrips } = getPreviousAndUpcomingTrips(data.bookings.data, format);
                setCount(data.bookings.last_page);
                setResultsPerPage(data.bookings.per_page);
                setPreviousTrips(previousTrips);
                setUpcomingTrips(upcomingTrips);
                if (isDealerSite() && relatedAccounts.length === 0 && data.subAccounts)
                    setRelatedAccounts(data.subAccounts);
            }
        } catch (e) {
            if (e.status === 401) signOut();
        }
    };


    const fetchDestinations = async () => {
        const {data} = await requestApi('get-destinations');
        if (data.status === 'success')
            setDestinations(data.data);
    };

    const getPreviousAndUpcomingTrips = (data,format='yyyy-MM-dd') => {
        const previousTrips = data.filter(t => isPast(endOfDay(parse((format==='yyyy-MM-dd'?t.tripDate:t['upcoming_date']), format, new Date()))));
        const upcomingTrips = data.filter(t => isFuture(endOfDay(parse((format==='yyyy-MM-dd'?t.tripDate:t['upcoming_date']), format, new Date()))));
        return {previousTrips, upcomingTrips};
    };

    const applyFilters = async () => {
        await getUserTrips();
    };
    const handleFilterChange = (filterName, newValue) => {
        const newFilterObj = {...filters};
        newFilterObj[filterName] = newValue;
        setFilters(newFilterObj);
    };
    const switchUserId = (newValue) => {
        setBookingUserId(newValue);
    };

    const handleClearFilters = () => {
        const newFilterObj = {...filters};
        for (let key in newFilterObj) {
            newFilterObj[key] = '';
        }
        setFilters(newFilterObj);
    };

    const filterBtnStyle = {
        margin: {
            md: '0'
        }
    };

    const clearFilterBtnStyle = {
        margin: {
            xs: '0 auto',
            md: '0'
        }
    };

    let yearsAmount = 8;
    const maxYear = window['availMaxYear'] ? parseInt(window['availMaxYear']) : null;

    const firstYearOption = new Date().getFullYear() - 5;

    if (maxYear) yearsAmount = (maxYear - firstYearOption) + 1;
    if (yearsAmount < 1) yearsAmount = 1;
    if (yearsAmount > 20) yearsAmount = 20;

    const yearList = Array.from(Array(yearsAmount), (_, i) => (firstYearOption + i).toString());

    const months = [
        {id: '01', label: 'January'},
        {id: '02', label: 'February'},
        {id: '03', label: 'March'},
        {id: '04', label: 'April'},
        {id: '05', label: 'May'},
        {id: '06', label: 'June'},
        {id: '07', label: 'July'},
        {id: '08', label: 'August'},
        {id: '09', label: 'September'},
        {id: '10', label: 'October'},
        {id: '11', label: 'November'},
        {id: '12', label: 'December'},
    ];

    return (
        <Container style={{marginBottom: '50px'}} sx={{px: {xs: '1.6rem', lg: '0'}}}>
            { isDealerSite() && <Grid container sx={{px: {xs: '1.6rem', lg: '0'}}}>
                <h2>See related accounts</h2>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={3}>
                        <FormControl variant="filled" fullWidth>
                            <InputLabel id="bookingAccountLabel">Select Account</InputLabel>
                            <Select
                                labelId="bookingAccountLabel"
                                id="bookingAccount"
                                name="bookingAccount"
                                label="Account"
                                value={bookingUserId}
                                onChange={(e) => switchUserId(e.target.value)}
                                disableUnderline
                            >
                                <MenuItem value={user().id}>Current Account</MenuItem>
                                {relatedAccounts.map(a => <MenuItem value={a.id} key={a.id}>{`${a.firstname} ${a.lastname}`}</MenuItem>)}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <PrimaryButton style={{width: 'auto'}} sx={filterBtnStyle} onClick={applyFilters}>
                            Switch Account
                        </PrimaryButton>
                    </Grid>
                </Grid>
            </Grid>}
            <Box sx={{ borderBottom: 1, borderColor: 'divider', mt: 4 }}>
                <NautilusTabs
                    value={selectedTab}
                    onChange={handleTabChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="fullWidth"
                    aria-label="Type of Trips"
                >
                    <NautilusTab label="Multi Day Trips"  {...a11yProps(0)} />
                    <NautilusTab label="Day Trips" {...a11yProps(1)} />
                </NautilusTabs>
            </Box>

            <Grid container sx={{px: {xs: '1.6rem', lg: '0'}}}>
                <h2>Filters</h2>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={3}>
                        <FormControl variant="filled" fullWidth>
                            <InputLabel htmlFor="confirmation">Confirmation # / Booking ID</InputLabel>
                            <FilledInput id="confirmation" name="confirmation"
                                         value={filters['confirmation']}
                                         onChange={(e) => handleFilterChange('confirmation', e.target.value)}
                                         disableUnderline/>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <FormControl variant="filled" fullWidth>
                            <InputLabel id="destinationLabel">Destination</InputLabel>
                            <Select
                                labelId="destinationLabel"
                                id="destination"
                                name="destination"
                                label="Destination"
                                value={filters['destination']}
                                onChange={(e) => handleFilterChange('destination', e.target.value)}
                                disableUnderline
                            >
                                <MenuItem value={''}>All</MenuItem>
                                {destinations.map(d => <MenuItem value={d.id} key={d.id}>{d.value}</MenuItem>)}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <FormControl variant="filled" fullWidth>
                            <InputLabel id="yearLabel">Year</InputLabel>
                            <Select
                                labelId="yearLabel"
                                id="year"
                                name="year"
                                label="Year"
                                value={filters['year']}
                                onChange={(e) => handleFilterChange('year', e.target.value)}
                                disableUnderline
                            >
                                <MenuItem value={''}>Any Year</MenuItem>
                                {yearList.map(year => <MenuItem value={year} key={year}>{year}</MenuItem>)}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <FormControl variant="filled" fullWidth>
                            <InputLabel id="monthLabel">Month</InputLabel>
                            <Select
                                labelId="monthLabel"
                                id="month"
                                name="month"
                                label="Month"
                                value={filters['month']}
                                onChange={(e) => handleFilterChange('month', e.target.value)}
                                disableUnderline
                            >
                                <MenuItem value={''}>Any Month</MenuItem>
                                {months.map(m => (
                                    <MenuItem key={m.id} value={m.id}>{m.label}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    {/*<Grid item xs={12} md={2}>
                        <FormGroup style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        size={'medium'}
                                        color={'primary'}
                                        checked={filters['dayTrip']}
                                        value={filters['dayTrip']}
                                        name="searchDayTrips"
                                        onChange={(e) => handleFilterChange('dayTrip', e.target.checked)}
                                    />
                                }
                                label=""
                            />
                            <span style={{fontSize: '1.2rem'}}>Show My Day Trips Only</span>
                        </FormGroup>
                    </Grid>*/}
                </Grid>
                <Grid container spacing={3} style={{marginTop: '10px'}}>
                    <Grid item xs={12} md={6}>
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <PrimaryButton style={{width: 'auto'}} sx={filterBtnStyle} onClick={applyFilters}>
                                    Apply Filters
                                </PrimaryButton>
                            </Grid>
                            <Grid item xs={12}>
                                <SecondaryButton style={{width: 'auto'}} sx={clearFilterBtnStyle}
                                                 onClick={handleClearFilters}>
                                    Clear Filters
                                </SecondaryButton>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            {!loadingBookings && totalResults === 0 && <Typography style={{marginTop: '20px'}}>No trips found.</Typography>}
            {loadingBookings && <div style={{marginTop: '20px', display: 'flex', justifyContent: 'center'}}><Spinner /></div>}
            {upcomingTrips.length > 0 && <>
                <Typography variant="h5" style={{fontSize: '2.4rem', fontWeight: '600', marginTop: '20px'}}
                            sx={{mx: {xs: '1.6rem', lg: '0'}}}>Upcoming trips</Typography>
                {upcomingTrips.length < 1 ? 'No trips available' : upcomingTrips.map((booking,i) => (
                    selectedTab === 1
                        ? <FareharborBookingCard booking={booking} key={i} update />
                        : <TripCard booking={booking} key={i} update />
                ))}
            </>}
            {previousTrips.length > 0 && <>
                <Typography variant="h5" style={{fontSize: '2.4rem', fontWeight: '600', marginTop: '20px'}}
                            sx={{mx: {xs: '1.6rem', lg: '0'}}}>Previous trips</Typography>
                {previousTrips.length < 1 ? 'No trips available' : previousTrips.map((booking,i) => (
                    selectedTab === 1
                        ? <FareharborBookingCard booking={booking} key={i}/>
                        : <TripCard booking={booking} key={i}/>

                ))}
            </>}
            {totalResults > 0 && count > 0 &&
                <div style={{marginTop: '50px', display: 'flex', justifyContent: 'center'}}>
                    <Pagination
                        count={count}
                        page={currentPage}
                        onChange={(event, value) => setCurrentPage(value)}
                        color="primary"
                    />
                </div>}

        </Container>
    );
};

export default BookingList;